module.exports = __webpack_public_path__ + "static/media/ana-bernardo.becb7cfb.jpg";